import React, { useEffect, useState } from "react";

import Table from "../table/table.component";
import useAppContext from "../../../hooks/useAppContext";

import { StyledWrapper } from "./tableWrapper.style";
import { tableConfig } from "./constants";

const TableWrapper = ({ name, set }) => {
  const { axios } = useAppContext();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const settings = tableConfig[name];

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(settings.url, {
        params: {
          set: set,
        },
      })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [set, settings]);

  return (
    <StyledWrapper>
      <Table data={data} isLoading={isLoading} set={set} {...settings} />
    </StyledWrapper>
  );
};

export default TableWrapper;
